/**
 * Minimal TipTap node extensions for native HTML <details>/<summary>.
 *
 * The editor sets HTML produced by marked.parse(...), so <details> wraps an
 * already-rendered <ul>/<p>/etc. These nodes just teach ProseMirror to keep
 * the elements intact and round-trip them back to native HTML so the browser
 * handles the toggle behaviour.
 *
 * @module automation-run/extensions/DetailsExtension
 */

import { Node, mergeAttributes } from '@tiptap/core';

export const Details = Node.create({
  name: 'details',
  group: 'block',
  content: 'summary block+',
  defining: true,

  parseHTML() {
    return [{ tag: 'details' }];
  },

  renderHTML({ HTMLAttributes }) {
    // Force open by default so the body is visible on first render;
    // clicking the summary still toggles closed via native browser behaviour.
    return ['details', mergeAttributes(HTMLAttributes, { open: '' }), 0];
  },
});

export const Summary = Node.create({
  name: 'summary',
  content: 'inline*',
  defining: true,

  parseHTML() {
    return [{ tag: 'summary' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['summary', mergeAttributes(HTMLAttributes), 0];
  },
});
